<template>
  <div>
    <div class="row no-gutters w-100">
      <div class="col-md-3 w3-card-2">
        <div class=" w3-bar-block w3-animate-left" id="mySidebar1">
          <div id="sidebar-tabs" class="nav nav-tabs custom-sidebar-nav-tabs" role="tablist">
            <!-- JobType/Category Filter-->
            <a href="#" class="w3-bar-item w3-button custom-bar-item custom-active text-decoration-none"
              data-toggle="collapse" data-target="#id-category" aria-expanded="false" ariacontrols="id-category">
              <div class="custom-sidebar-heading">
                <div class="custom-row">
                  <div class="custom-sidebar-icons">
                    <b-icon icon="shop"></b-icon>
                  </div>
                  <div class="custom-sidebar-text">
                    <span>Category</span>
                  </div>
                </div>
                <div class="custom-sidebar-icons custom-add-btn">
                  <a href="#" class="custom-sidebar-link">
                    <b-icon class="custom-arrow-icon" icon="chevron-down"></b-icon>
                  </a>
                </div>
              </div>
            </a>
            <div id="id-category" class="collapse custom-collapse show" aria-labelledby="sidebar-tabs"
              data-parent="#sidebar-tabs">
              <div v-if="filter.JobSubTypes[0] != null && filter.JobSubTypes[0] == 24">
                <div style="border: solid 2px; margin: 0.5rem;padding: 0.5rem;">
                  Mums Back to Work is specifically designed to cater to the needs of moms who have taken a break from
                  their careers to raise children, and are now ready to jump back into the job market.
                </div>
              </div>
              <div v-if="filter.JobSubTypes[0] != null && filter.JobSubTypes[0] == 25">
                <div style="border: solid 2px; margin: 0.5rem;padding: 0.5rem;">
                  Paid Internship Placement for minimum 3 months in the relevant field of expertise.
                </div>
              </div>
              <div v-if="filter.JobSubTypes[0] != null && filter.JobSubTypes[0] == 26">
                <div style="border: solid 2px; margin: 0.5rem;padding: 0.5rem;">
                  It is a paid internship in any relevant field of expertise with 8-10 Weeks of internship in any of the
                  company.
                </div>
              </div>
              <div v-if="filter.JobSubTypes[0] != null && filter.JobSubTypes[0] == 41">
                <div style="border: solid 2px; margin: 0.5rem;padding: 0.5rem;">
                  This is an excellent resource for students/graduates who are looking for short-term, project-based
                  work
                  that can be done remotely or with flexible hours.
                </div>
              </div>
              <div v-if="filter.JobSubTypes[0] != null && filter.JobSubTypes[0] == 30">
                <div style="border: solid 2px; margin: 0.5rem;padding: 0.5rem;">
                  This section offers a range of job listings from companies that prioritize diversity, equity, and
                  inclusion, and are committed to providing reasonable accommodations for employees with disabilities
                </div>
              </div>
              <div v-if="filter.JobSubTypes[0] != null && filter.JobSubTypes[0] == 105">
                <div style="border: solid 2px; margin: 0.5rem;padding: 0.5rem;">
                  we provide the world wide jobs here.
                </div>
              </div>
              <div v-if="filter.JobSubTypes[0] != null && filter.JobSubTypes[0] == 254">
                <div style="border: solid 2px; margin: 0.5rem;padding: 0.5rem;">
                  Labour Man Power - Technical Staff
                </div>
              </div>
              <div v-if="filter.JobSubTypes[0] != null && filter.JobSubTypes[0] == 259">
                <div style="border: solid 2px; margin: 0.5rem;padding: 0.5rem;">
                  Others
                </div>
              </div>

              <b-form-group class="border-0">
                <div v-if="isLoadingCategories" class="category-skeleton">
                  <div v-for="n in 8" :key="'category-skeleton-' + n" class="skeleton-checkbox mb-2">
                    <div class="skeleton-checkbox-box"></div>
                    <div class="skeleton-checkbox-label"></div>
                  </div>
                </div>
                <template v-else>
                  <b-form-checkbox v-for="(option, index) in categories" v-model="selectedJobSubType" :key="option.key"
                    :value="option.key" class="mt-2 custom-checkbox-color w3-animate-opacity"
                    @change="getJobsByFilters">
                    <span>


                      <a :class="{ 'font-weight-bold': option.key === 2487 || option.key === 105 }">{{ option.value
                        }}</a>

                      <div v-if="option.key == 30" id="chkDisabiltyTypes" class="hideDiv">
                        <b-form-checkbox v-for="(option, index) in disabilityTypes" v-model="filter.disabilityTypes"
                          :key="option.key" :value="option.key" class="mt-2 custom-checkbox-color w3-animate-opacity"
                          @change="getJobsByFilters">
                          <span>
                            <a> {{ option.value }} </a>
                          </span>
                        </b-form-checkbox>
                      </div>
                    </span>
                  </b-form-checkbox>
                </template>
              </b-form-group>

            </div>
            <!-- JobSubType/JobType Filter-->
            <a href="#" class="w3-bar-item w3-button custom-bar-item custom-active text-decoration-none collapsed"
              data-toggle="collapse" data-target="#id-jobtype" aria-expanded="false" ariacontrols="id-jobtype">
              <div class="custom-sidebar-heading">
                <div class="custom-row">
                  <div class="custom-sidebar-icons">
                    <b-icon icon="shop"></b-icon>
                  </div>
                  <div class="custom-sidebar-text">
                    <span>Job Type</span>
                  </div>
                </div>
                <div class="custom-sidebar-icons custom-add-btn">
                  <a href="#" class="custom-sidebar-link">
                    <b-icon class="custom-arrow-icon" icon="chevron-down"></b-icon>
                  </a>
                </div>
              </div>
            </a>
            <div id="id-jobtype" class="collapse custom-collapse collapse" aria-labelledby="sidebar-tabs"
              data-parent="#sidebar-tabs">
              <b-form-group class="border-0">
                <b-form-checkbox v-for="option in jobTypes" v-model="selctedJobType" :key="option.key"
                  :value="option.key" class="mt-2 custom-checkbox-color w3-animate-opacity" @change="getJobsByFilters">
                  {{ option.value }}
                </b-form-checkbox>
              </b-form-group>
            </div>
            <!-- Experience Filter-->
            <a href="#" class="w3-bar-item w3-button custom-bar-item custom-active text-decoration-none collapse"
              data-toggle="collapse" data-target="#id-experience" aria-expanded="false" ariacontrols="id-experience">
              <div class="custom-sidebar-heading">
                <div class="custom-row">
                  <div class="custom-sidebar-icons">
                    <b-icon icon="shop"></b-icon>
                  </div>
                  <div class="custom-sidebar-text">
                    <span>Experience</span>
                  </div>
                </div>
                <div class="custom-sidebar-icons custom-add-btn">
                  <a href="#" class="custom-sidebar-link">
                    <b-icon class="custom-arrow-icon" icon="chevron-down"></b-icon>
                  </a>
                </div>
              </div>
            </a>
            <div id="id-experience" class="collapse custom-collapse collapse" aria-labelledby="sidebar-tabs"
              data-parent="#sidebar-tabs">
              <b-form-group class="border-0">
                <b-form-checkbox v-for="(option, index) in visibleExperiences" v-model="selectedExperince"
                  :key="option.key" :value="option.key" class="mt-2 custom-checkbox-color" @change="getJobsByFilters">
                  {{ option.value }}


                </b-form-checkbox>
                <!--  View More Button    -->
                <div v-if="visibleExperiences != null">
                  <div v-if="experiencesVisible < filteredExperiences.length">
                    <div class="text-center clear-bottom">
                      <a href="javascript:void(0)" @click="experiencesVisible += step" class="text-decoration-none">
                        View More
                      </a>
                    </div>
                  </div>
                </div>
              </b-form-group>
            </div>
            <!-- cityFilter-->
            <a href="#" class="w3-bar-item w3-button custom-bar-item custom-active text-decoration-none collapse"
              data-toggle="collapse" data-target="#id-city" aria-expanded="false" ariacontrols="id-city">
              <div class="custom-sidebar-heading">
                <div class="custom-row">
                  <div class="custom-sidebar-icons">
                    <b-icon icon="shop"></b-icon>
                  </div>
                  <div class="custom-sidebar-text">
                    <span>City</span>
                  </div>
                </div>
                <div class="custom-sidebar-icons custom-add-btn">
                  <a href="#" class="custom-sidebar-link">
                    <b-icon class="custom-arrow-icon" icon="chevron-down"></b-icon>
                  </a>
                </div>
              </div>
            </a>
            <div id="id-city" class="collapse custom-collapse collapse" aria-labelledby="sidebar-tabs"
              data-parent="#sidebar-tabs">
              <b-form-group class="border-0">
                <b-form-checkbox v-for="option in filteredCities" v-model="selectedfilterCityList" :key="option.key"
                  :value="option.key" class="mt-2 custom-checkbox-color w3-animate-opacity" @change="getJobsByFilters">
                  {{ option.value }}
                </b-form-checkbox>
                <b-form-checkbox v-for="option in otherOptions" v-model="filter.isOthersSelected" value-field="item"
                  text-field="value" class="mt-2 custom-checkbox-color w3-animate-opacity" @change="getJobsByFilters">
                  {{ option.value }}
                </b-form-checkbox>
              </b-form-group>
            </div>
            <!-- Degree Level Filter-->
            <a href="#" class="w3-bar-item w3-button custom-bar-item custom-active text-decoration-none collapse"
              data-toggle="collapse" data-target="#id-degreelevel" aria-expanded="false" ariacontrols="id-degreelevel">
              <div class="custom-sidebar-heading">
                <div class="custom-row">
                  <div class="custom-sidebar-icons">
                    <b-icon icon="shop"></b-icon>
                  </div>
                  <div class="custom-sidebar-text">
                    <span>Degree Level</span>
                  </div>
                </div>
                <div class="custom-sidebar-icons custom-add-btn">
                  <a href="#" class="custom-sidebar-link">
                    <b-icon class="custom-arrow-icon" icon="chevron-down"></b-icon>
                  </a>
                </div>
              </div>
            </a>
            <div id="id-degreelevel" class="collapse custom-collapse collapse" aria-labelledby="sidebar-tabs"
              data-parent="#sidebar-tabs">
              <b-form-group class="border-0">
                <b-form-checkbox v-for="option in degreeLevels" v-model="SelectedDegreeLevel" :key="option.key"
                  :value="option.key" class="mt-2 custom-checkbox-color" @change="getJobsByFilters">
                  {{ option.value }}
                </b-form-checkbox>
              </b-form-group>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-9">
        <div style="min-height: 176.6875rem;">
          <div class="custom-category-title" v-if="isCategoryVisible">
            <span style="color: #ea216c"><b-icon icon="caret-right-fill"></b-icon></span>
            <span v-if="categoryValue != []" class="text-capitalize">
              <span v-for="(data, index) in categoryValue" :key="data.id">
                <span>{{ data.title }}<span class="ml-1 mr-1"> </span></span>
              </span>
            </span>
          </div>
          <div class="custom-jobs-heading text-center  pt-4 pb-4">
            <div class="container">
              
              <p class="headingstyles"><b>Find Your Next Job, Fast</b></p>
              <p>View by Experience, Search by Skills</p>
              <!--              <p>Search By Skills, View Salaries, One-Click Apply</p>-->
              <form class="">
                <div class="row">
                  <div class="col-md-1"></div>
                  <div class="col-md-5">
                    <div class="mb-2">
                      <!--                <label  class="sr-only">Email</label>-->
                      <input type="text" v-model="filter.JobTitle" @keydown.enter.prevent="getJobsByFilters"
                        class="form-control custom-input-gotopage custom-job-search-input" placeholder="Job Title">
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="mb-2">
                      <!--                <label  class="sr-only">Password</label>-->
                      <select id="city_id" class="custom-select-option custom-select-city-option form-control"
                        v-model="selectedfilterCityList" selected="selectedCity">
                        <option value=0>Select City</option>
                        <option v-for="option in cities" :key="option.key" :value="option.key">
                          {{ option.value }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-2">
                    <div class="mb-2">
                      <button type="button" @click="getJobsByFilters"
                        class="btn btn-primary custom-employer-btn custom-btn-apply-now custom-btn-search mb-2">
                        Search</button>
                    </div>
                  </div>
                  <div class="col-md-1"></div>
                </div>
              </form>
            </div>
          </div>
          <hr>
          <div>


            <div class="container pt-3 pb-3 ml-auto mr-auto" style="margin: 0px !important; max-width: 1269px;">
              <!-- Loading Skeletons -->
              <div v-if="isLoading" class="w3-animate-opacity skeleton-container" aria-busy="true">
                <div v-for="n in filter.PageSize" :key="'skeleton-' + n" class="skeleton-card">
                  <div class="skeleton-row">
                    <div class="skeleton-col-main">
                      <div class="skeleton-line title"></div>
                      <div class="skeleton-line meta"></div>
                      <div class="skeleton-line meta"></div>
                      <!-- <div class="skeleton-line tags"></div> -->
                      <div class="skeleton-line description"></div>
                      <div class="skeleton-line description"></div>
                      <div class="skeleton-line description-short"></div>
                    </div>
                    <div class="skeleton-col-side">
                      <div class="skeleton-button"></div>
                      <div class="skeleton-button"></div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Actual Content - Show only when not loading -->
              <div v-else>
                <div v-if="visibleRecords.length != 0">
                  <div v-for="(job, jobIndex) in visibleRecords" :key="job.jobId">
                    <div class="w3-card-2 pl-4 pr-4 pt-3 pb-3 w3-container mb-3 custom-job-card">
                      <div class="row align-items-center" style="margin: 1.375rem 0rem;">
                        <div class="col-md-10">
                          <router-link class="text-decoration-none"
                            :to="{ name: 'JobDetail', params: { id: job.jobId } }" title="Job Detail">
                            <div class="mb-2">
                              <h5 class="custom-job-title text-dark text-capitalize m-0"><u>{{ job.jobTitle }}</u></h5>
                            </div>
                            <div class="custom-row mb-2 custom-muted-text">
                              <span class="mr-2"><i class="fas fa-map-marker-alt"></i></span>
                              <span>{{ job.cityName }}, {{ job.countryName }}</span>
                            </div>
                            <div class="custom-row mb-2 custom-muted-text">
                              <span class="mr-2"><i class="fas fa-money-bill"></i></span>
                              <span v-if="job.packageTo === 0 || job.packageTo === 1">Market Competitive Salary</span>
                              <span v-else>Rs {{ job.packageFrom }} - {{ job.packageTo }}/Month</span>
                            </div>
                            <div class="custom-row mb-2">
                              <span>
                                <b-badge class="custom-status-badge" variant="primary">{{ job.category }}</b-badge>
                              </span>
                              <div class="pl-1 pr-1"></div>
                              <span v-if="job.experiencelevel !== null">
                                <b-badge class="custom-status-badge" variant="primary">
                                  Experience: {{ job.experiencelevel }}
                                </b-badge>
                              </span>
                              <div class="pl-1 pr-1"></div>
                              <span>
                                <b-badge class="custom-status-badge" variant="primary">{{ job.jobTypeTitle }}</b-badge>
                              </span>
                            </div>
                          </router-link>
                          <div v-if="job.jobDescription != null" class="custom-muted-text text-justify">
                            <span class="font-weight-bold">Job Description:</span>
                            <br>
                            <span v-if="job.jobDescription.length > 100">
                              <span>{{ job.jobDescription.substr(0, 103) }}</span>
                              <span class="collapse w3-animate-opacity" :id="'readMoreSection' + jobIndex + 1">
                                {{ job.jobDescription.substr(103, job.jobDescription.length) }}
                              </span>
                              <span>
                                <a @click="onAreaExpand" class="custom-text-color text-decoration-none"
                                  data-toggle="collapse" :href="'#readMoreSection' + jobIndex + 1" role="button"
                                  aria-expanded="false" aria-controls="collapseExample">
                                  <span class="w3-animate-opacity" style="float: right;"
                                    v-if="isAreaExpanded == false">Read More>></span>
                                  <span class="w3-animate-opacity" style="float: right;" v-else>
                                    Read Less</span>
                                </a>
                              </span>
                            </span>
                            <span v-else>
                              {{ job.jobDescription }}
                            </span>
                          </div>
                          <div v-else></div>
                        </div>
                        <div class="col-md-2 text-center">
                          <div class="mb-3">
                            <span class="flex-grow-1">
                              <span v-if="disableEasyApplyButton">
                                 <router-link class="text-decoration-none" 
                            :to="{ name: 'JobDetail', params: { id:job.jobId } }" title="Job Detail">
                                <a 
                                  class="btn btn-primary custom-employer-btn custom-btn-apply-now mb-2" >
                                  Easy Apply
                                </a>
                                </router-link>
                              </span>
                            </span>
                          </div>
                          <div class="">
                            <a class="btn btn-primary custom-employer-btn custom-btn-apply-now custom-btn-bookmark"
                              @click="onSavingJob(job)">Save</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>


                <!-- Pagination -->
                 <p style="display: flex;">{{displayJobFrom}}- {{displayUpTo}} out of {{ totalJobs }}</p>
                <div class="text-center clear-bottom">
                  
                  <div class="row no-gutters" style="display: flex; justify-content: space-around;">
                    <div style="">
                      <div v-if="totalPages && totalPages.length > 0" class="text-center">
                        
                        <!-- First Button -->
                        <a href="javascript:void(0)" @click="goToPage(1)"
                          class="btn btn-theme text-decoration-none mx-1"
                          :class="{ 'btn-primary': filter.PageNumber === 1, 'btn-secondary': filter.PageNumber !== 1 }">
                          First
                        </a>
                        <!-- Previous Button -->
                        <a v-if="filter.PageNumber > 1" href="javascript:void(0)"
                          @click="goToPage(filter.PageNumber - 1)"
                          class="btn btn-theme text-decoration-none mx-1 btn-secondary">
                          Prev
                        </a>
                        <!-- Page Numbers (max 5) -->
                        <a v-for="page in visiblePages" :key="page" href="javascript:void(0)" @click="goToPage(page)"
                          class="btn btn-theme text-decoration-none mx-1" :class="{
                'btn-primary': filter.PageNumber === page,
                'btn-secondary': filter.PageNumber !== page,
                'btn-active-page': filter.PageNumber === page
              }">
                          {{ page }}
                        </a>

                        <!-- Next Button -->
                        <a v-if="filter.PageNumber < totalPages.length" href="javascript:void(0)"
                          @click="goToPage(filter.PageNumber + 1)"
                          class="btn btn-theme text-decoration-none mx-1 btn-secondary">
                          Next
                        </a>

                        <!-- Last Button -->
                        <a href="javascript:void(0)" @click="goToPage(totalPages.length)"
                          class="btn btn-theme text-decoration-none mx-1" :class="{
                'btn-primary': filter.PageNumber === totalPages.length,
                'btn-secondary': filter.PageNumber !== totalPages.length
              }">
                          Last
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <CPModal v-if="isModalVisible" :save-job-status="isSaveJobStatus" :signInOrSignUpSection="isSignInOrSignUpSection"
      :istakeResumeAfterSignin="istakeResumeAfterSignin" :employeeProfileFormSection="isEmployeeProfileFormSection"
      :show-alert-msg="isShowAlertMsg" :show-profile-info-card="isShowProfileInfoCard"
      :apply-job-confirmation-section="isApplyJobConfirmationSection" :selected-job-record="jobRecord"
      @get-strength="recievedStrength" @toggle-modal="toggleModal"
      :jobDataForResumeInputModalPopup="jobDataForModalPopup">

    </CPModal>
    <ConfirmationModal v-if="isConfirmationModalVisible" @toggle-modal="closeModal"></ConfirmationModal>

  </div>
</template>
<script>
import Vue from 'vue';
import axios from "axios";
import moment from "moment";
//Vue.use(moment);
import CPModal from "../components/employeeComponents/CompleteProfileModalComponent";
import _ from "underscore";
import ConfirmationModal from "../components/ConfirmationModal";
import { isNull } from 'underscore';
export default {
  name: "AllJobs",
  components: {
    ConfirmationModal,
    CPModal,
  },
  data() {
    return {
      isLoading : true,
      istakeResumeAfterSignin:false,
      displayJobFrom: 0,
      displayUpTo: 0,
      isLoadingCategories:true,
      url: axios.defaults.baseURL,
      info: null,
      list: [],
      username: '',
      //alert msg
      dismissSecs: 5,
      dismissCountDown: 0,
      jobId: 0,


      isCategoryVisible: false,
      isCategoryChecklistVisible: false,
      categoryValue: {
        value: []
      },
      selectedCity: 0,
      jobSearchByNameOrCity: {
        jobTitle: "",
        cityId: null
      },
      isSelectedOther: false,
      otherOptions: [
        { item: false, value: "Others" }
      ],
      ShowDisabilityTypesChecks: false,
      selectedDisabilityType: null,
      filter: {
        JobTypes: [],
        JobSubTypes: [],
        disabilityTypes: [],
        Cities: [],
        DegreeLevels: [],
        EmpExperiences: [],
        isOthersSelected: false,
        PageSize: 10,
        PageNumber: 1,
        TotalRecord: 0,
        JobTitle: null,

        Text: null
      },
      //cities:null,
      //categories:[],
      categoriesCount: null,
      //jobTypes:[],
      //filteredExperiences:[],
      //yearsOfExperiences:[],

      //filteredCities:[],
      //degreeLevels:[],

      currentDate: new Date(),
      insertionDates: [],
      dateDifferences: [],
      isApplyNow_btn: true,
      isApplied_btn: false,
      disableEasyApplyButton: false,
      showAssessmentButton: false,
      unansweredQuestions: [],

      job: {
        JobId: 0,
        EmployeeId: 0,
        ExpectedSalary: 0,
        Status: 1,
        IsApplicantViewed: false
      },

      isSaveJobStatus: false,


      saveJob: {
        saveJobId: 0,
        jobId: 0,
        employeeId: 0,
        isActive: true

      },
      jobID: 0,
      jobRecord: null,
      jobsStatuses: null,
      employeelist: null,
      employeeId: 0,
      employeeSkill: null,
      employeeExperience: null,
      employeeEducation: null,
      profileStrength: 0,


      isButtonVisible: false,

      //combined list with status
      listWithStatus: [],
      SelectedValues: [],
      //Complete Profile Modal
      isModalVisible: false,
      isConfirmationModalVisible: false,
      isSignInOrSignUpSection: false,
      isEmployeeProfileFormSection: false,
      isShowAlertMsg: false,
      isShowProfileInfoCard: false,
      isApplyJobConfirmationSection: false,
      modalMsg: "",
      showAlertMsg: false,
      modalDescription: "",
      errored: false,
      componentKey: 0,

      //Read More Collapse
      isAreaExpanded: false,

      // Show More Functionality
      isShowMoreBtnVisible: false,
      recordsVisible: 5,
      experiencesVisible: 10,
      step: 5,
      selectedJobSubType: 2487,
      selctedJobType: 0,
      selectedExperince: 0,
      selectedfilterCityList: 0,
      SelectedDegreeLevel: 0,
      jobDataForModalPopup: {
      title: '',
      companyName: '',
      cityName:'',
      countryName: '',
      scrapJobUrl:'',
    }

    };
    
  },
  mounted() {

    this.$root.$on('data-of-search', (msg) => {
      debugger
      //console.log(msg);
      this.selectedfilterCityList = msg.cityId;
      this.filter.JobTitle = msg.jobTitle;
      //console.log(this.jobSearchByNameOrCity);
    })
    this.isLoading=true;
    // this.getAllEmployees();
    this.getCategoryList();
    this.getJobTypesList();
    this.getExperienceList();
    this.getCityList();
    this.buttonsMethod();
    this.getDisabilityTypesList();
    this.getDegreeLevelsList();
    const triggerFilter = this.$route.query.triggerFilter;
    const searchFilter = this.$route.query.searchFilter ? JSON.parse(this.$route.query.searchFilter)
      : null;

    if (!triggerFilter) {
      // this.getAll();

    } else {
      this.jobSearchByNameOrCity.jobTitle = searchFilter.jobTitle;
      this.selectedCity = searchFilter.cityId ? searchFilter.cityId : 0;
      this.getJobsByNameAndCity();
    }
    this.filter.PageNumber = 1; // Ensure page is set to 1 on load
  this.displayJobCount(); // Set initial displayJobFrom and displayUpTo
    this.getJobsByFilters();
  

  },
  beforeCreate() {
    return this.$options.computed.visibleRecords;

  },

  computed: {
    visiblePages() {
      const current = this.filter.PageNumber;
      const total = this.totalPages.length;
      const maxPagesToShow = 5;
      let start = Math.max(current - Math.floor(maxPagesToShow / 2), 1);
      let end = start + maxPagesToShow - 1;

      if (end > total) {
        end = total;
        start = Math.max(end - maxPagesToShow + 1, 1);
      }

      const pages = [];
      for (let i = start; i <= end; i++) {
        pages.push(i);
      }
      return pages;
    },

    jobsList() {

      //console.log("joblist : ", this.$store.state.jobList)

      return this.$store.state.jobList;
    },
    totalJobs() {
      //console.log("totalJobs:", this.$store.getters.getTotalJobs);
      return this.$store.getters.getTotalJobs;
    },
    totalPages() {
      //console.log("TotalPages from store:", this.$store.getters.getTotalPages);
      return this.$store.getters.getTotalPages;
    },
    visibleRecords() {
      return this.jobsList;
      
    },
    cities() {
      return this.$store.getters.availableCities
    },
categories() {
  const originalCategories = this.$store.getters.availableCategories;
  
  // Filter and sort categories as needed
  return originalCategories.filter(
    cat => cat.key !== 259 && cat.key !== 25 // Remove unwanted categories
  ).sort((a, b) => {
    // Sort All Jobs (2487) first, then International (105), then others
    if (a.key === 2487) return -1;
    if (b.key === 2487) return 1;
    if (a.key === 105) return -1;
    if (b.key === 105) return 1;
    return 0;
  });
},


    disabilityTypes() {
      return this.$store.getters.availableDisabilityTypes
    },

    jobTypes() {
      return this.$store.getters.availableJobTypes
    },
    filteredExperiences() {
      return this.$store.getters.availableExperiences
    },
    visibleExperiences() {
      return this.filteredExperiences.slice(0, this.experiencesVisible)
    },

    filteredCities() {
      return this.$store.getters.availableFilteredCities
    },
    degreeLevels() {
      return this.$store.getters.availableDegreeLevels
    },
    categoryFilter() {
      //console.log("this.$store.state.categoryFilter : ", this.$store.state.categoryFilter)
      return this.$store.state.categoryFilter;
    },


  },

  methods: {
    goToPage(page) {
      if (page < 1 || page > this.totalPages.length) return;
      this.filter.PageNumber = page;
      this.displayJobCount();
      this.getJobsByFilters(); // Make sure this method updates the job list
     // Calculate displayJobFrom and displayUpTo
    this.$nextTick(() => {
    // Scroll to the top of the job listings container
    const container = document.querySelector('.custom-jobs-heading');
    if (container) {
      container.scrollIntoView({ 
        behavior: 'smooth', 
        block: 'start'  // Aligns top of container with viewport
      });
      // container.scrollIntoView({ behavior: 'smooth' });
    }
    
    // Alternative: Scroll to top of window
    // window.scrollTo({ top: 0, behavior: 'smooth' });
  });

    },
    displayJobCount() {
      this.displayJobFrom = (this.filter.PageNumber - 1) * this.filter.PageSize + 1;
      this.displayUpTo = this.filter.PageNumber * this.filter.PageSize;
    },
    getSelectedValues() {
      var radioButtons = [];
      var selectedValues = {};

      // Assuming you have radio buttons with names 'q1' to 'q24'
      for (var i = 1; i <= 24; i++) {
        radioButtons[i] = document.getElementsByName('q' + i);
        var userid = 0;
        var selectedInGroup = false;

        // Loop through the radio buttons to find the selected one
        for (var j = 0; j < radioButtons[i].length; j++) {
          if (radioButtons[i][j].checked) {

            selectedInGroup = true;

            selectedValues['q' + i] = radioButtons[i][j].value;
            var entry = {
              JobId: this.jobId,
              UserId: userid,
              Username: "test",
              QuestionNo: radioButtons[i][j].name,
              Answers: radioButtons[i][j].value
            };
            this.SelectedValues.push(entry);
            break;
          }
        }
        if (!selectedInGroup) {
          // Record unanswered question number
          this.unansweredQuestions.push(i);
        }
      }

      if (this.unansweredQuestions.length > 0) {
        // Show an alert or handle unanswered questions as needed
        alert('Please select an option for questions: ' + this.unansweredQuestions.join(', '));
        // Clear the unanswered questions array for the next attempt
        this.unansweredQuestions = [];
        return;
      }

      //console.log(this.SelectedValues);
      this.disableEasyApplyButton = true;


      // const modal = document.getElementById('surveyModal');
      // modal.style.display = 'none';


      axios
        .post("/api/Job/InsertAssesment", this.SelectedValues)
        .then(res => {
          // code that we will 'try' to run

          //console.log("InsertAssesment", res);
          //console.log("InsertAssesment data", res.data);
          //console.log("InsertAssesment data2", res.data.data);
          if (res.data.data == 3000) {
            alert('Already submitted the Assessment!');
            window.location.reload();
          }
          if (res.data.data == 2000) {
            alert('Assesment Saved Successfully!');
            window.location.reload();
          }
        })
        .catch(error => {
          //console.log("Errorrrrrr : ", error);
          this.errored = true;
        })
      //console.log(selectedValues);
    },
    getAll() {
      this.isLoading=true;
      try{
      this.rerender();

      // //console.log("this.$route.params : ", this.$route.params);
      // //console.log("this.$route.params.cId : ", this.$route.params.cId);

      // Check if a company ID is provided in the route parameters
      if (this.$route.params.cId != undefined) {
        this.$store.dispatch("getJobsByCompanyId", this.$route.params.cId);

        // Adjust packageFrom if packageTo is 0
        if (this.job.packageTo === 0 || this.job.packageTo === 1) {
          this.job.packageFrom = null;
        }
      }
      else {
        // this.$store.dispatch("getAll");

        // Adjust packageFrom if packageTo is 0
        if (this.job.packageTo === 0 || this.job.packageTo === 1) {
          this.job.packageFrom = null;
        }
      }

      // Ensure jobData is initialized to an empty object
      if (!this.jobData) {
        this.jobData = {};
      }
      } catch (error) {
    console.error("Error fetching all jobs:", error);
  }   setTimeout(() => {
      this.isLoading = false;
    }, 300);
    },


    showMore() {
      this.recordsVisible += 5;
    },
    getAllEmployees() {
      //this.rerender();
      //this.profileStrength = 0;
      this.employeelist = null;
      axios.get('/api/Employee/GetEmployeeProfile')
        .then(res => {
          if (res.status != '200') {
            //console.log('error.....')
            const error = new Error('Failed to fetch!');
            return error;
          }



          this.employeelist = res.data.employee;
          //console.log("employeelist : ", this.employeelist);


          this.employeeId = this.employeelist.employeeId;
          this.job.ExpectedSalary = this.employeelist.expectedSalary;

          this.employeeSkill = res.data.eMPSkills;
          //console.log("employeeSkill : ", this.employeeSkill);
          this.employeeExperience = res.data.eMPExperiences;



          this.employeeEducation = res.data.empEducations;
          //console.log("employeeEducation : ", this.employeeEducation);


          this.CalculatePercentage();


          // });
        }).catch(error => {
          //console.log(error);
          this.errored = true;
        })
        .finally(() => {
          if (this.errored) {

            //console.log("Error : Sorry there is no response");
            // this.$bvToast.toast("Sorry there is no response ", {
            //   toaster: "b-toaster-top-center",
            //   variant: "danger",

            //   solid: true,
            // });
          }
        });
    },
    getJobsByNameAndCity() {
      //this.list = [];
      if (this.jobSearchByNameOrCity.jobTitle != "" || this.selectedCity != 0) {

        this.jobSearchByNameOrCity.cityId = (this.selectedCity == 0 || this.selectedCity == null) ? null : Number(this.selectedCity)


        this.$store.dispatch("getJobsByNameAndCityId", this.jobSearchByNameOrCity)
      }
      else {

        this.$route.params.jobTitle = undefined;
        this.$route.params.selectedCity = undefined;
        this.getJobsByFilters();
      }
    },

    //Get Dropdowns List
    getCityList() {

      this.$store.dispatch("getCityList")
    },
    getCategoryList() {
 this.isLoadingCategories = true;
    this.$store.dispatch("getCategories")
      .then(() => {
        this.isLoadingCategories = false;
      })
      .catch(() => {
        this.isLoadingCategories = false;
      });
  

    },
    getExperienceList() {

      this.$store.dispatch("getExperiences")
    },
    getJobTypesList() {

      this.$store.dispatch("getJobTypes")

    },

    getDegreeLevelsList() {

      this.$store.dispatch("getDegreeLevel")


    },
    getDisabilityTypesList() {
      this.$store.dispatch("getDisailityTypes")
      //console.log("get Disability is hit")
    },
    toggleDisabilityTypes() {

      if (chkDisability) {
        // Toggle the display between 'block' and 'none'

      }
    },
    getJobsByFilters() {
      this.isLoading = true;
      try {
        this.rerender();
        this.isCategoryVisible = false;
        this.list = [];
        if (this.selectedJobSubType == 30) {
          const chkDisability = document.getElementById('chkDisabiltyTypes');
          chkDisability.classList.remove("hideDiv");
        } else {
          const chkDisability = document.getElementById('chkDisabiltyTypes');
          if (chkDisability != null) {
            chkDisability.classList.add("hideDiv");
          }
        }
        //console.log("this.filter in jobboard : ", this.filter);
        //this.jobSearchByNameOrCity.cityId = Number(this.selectedCity);
        // if (this.selctedJobType != 0 || this.selectedJobSubType != 0 || this.selectedfilterCityList != 0 || this.selectedExperince != 0 || this.filter.disabilityTypes.length > 0 || this.SelectedDegreeLevel != 0 || this.filter.JobTitle != null) {
          if (this.selectedJobSubType == false) {
            this.selectedJobSubType = 0;
            this.filter.JobSubTypes = [this.selectedJobSubType];
          } else {
            if (this.selectedJobSubType == 2487) {
          
              this.filter.JobSubTypes=[0];
            }else{
              this.filter.JobSubTypes = [this.selectedJobSubType];
            }
            
          }
          if (this.selctedJobType == false) {
            this.selctedJobType = 0;
          }
          if (this.selectedfilterCityList == false) {
            this.selectedfilterCityList = 0;
          }
          if (this.selectedExperince == false) {
            this.selectedExperince = 0;
          }
          if (this.SelectedDegreeLevel == false) {
            this.SelectedDegreeLevel = 0;
          }
          this.filter.JobTypes = [this.selctedJobType];
          this.filter.Cities = [this.selectedfilterCityList];
          this.filter.EmpExperiences = [this.selectedExperince];
          this.filter.DegreeLevels = [this.SelectedDegreeLevel];

          //console.log("thisisthefilter", this.filter)
          this.$store.dispatch("getJobsByFilters", this.filter)

          this.categoryValue = []

          if (this.selectedJobSubType) {
            const selectedCategory = this.categories.find(
              (data) => data.key === this.selectedJobSubType
            );

            if (selectedCategory) {
              this.categoryValue.push({
                id: selectedCategory.key,
                title: selectedCategory.value,
              });
            }
          }
          //console.log("categoryValueList : ", this.categoryValue)
          if (this.categoryValue.length != 0) {
            this.isCategoryVisible = true;
          }
          else {
            this.isCategoryVisible = false;
          }
        // }
        // else {
          // this.getAll();
        // }
      } catch (error) {
        console.error("Error fetching jobs:", error);
      } finally {
         setTimeout(() => {
        this.isLoading = false;
      }, 500);
      }
    },
    buttonsMethod() {
      // If the company name is 'Unze London', show the assessment button and enable the easy apply button
      this.showAssessmentButton = false;
      this.disableEasyApplyButton = true;
    },
    submitAssessment(jobId) {
      // Your logic to submit the assessment modal
      this.jobId = jobId;
      // After submission, disable the easy apply button
      this.disableEasyApplyButton = true;
    },


 showOrHideModal(jobrecord) {
  this.jobRecord = jobrecord;
  this.jobDataForModalPopup = {
    title: jobrecord.jobTitle || '',
    companyName: jobrecord.companyName || '',
    countryName: jobrecord.countryName || '',
    scrapJobUrl : jobrecord.scrapJobUrl|| '',
    cityName : jobrecord.cityName || '',
  };

  if (this.$auth.check()) {
    //console.log("check : ", this.$auth.check());
    if (this.$auth.user().user.role !== 'Employer') {
      if (jobrecord.isScrapJob) {
       this.isModalVisible = true;
        this.istakeResumeAfterSignin = true;
        this.isSignInOrSignUpSection = false;
         this.isEmployeeProfileFormSection = false;
        this.isShowAlertMsg = false;
        this.isShowProfileInfoCard = false;
        this.isApplyJobConfirmationSection = false;

        // For scraped jobs, open the scrapJobUrl in a new tab
        // if (jobrecord.scrapJobUrl) {
        //   alert('hit the url')
        //   // window.open(jobrecord.scrapJobUrl, '_blank');
        // } else {
        //   this.$bvToast.toast("No valid URL available for this job.", {
        //     toaster: "b-toaster-top-center",
        //     variant: "warning",
        //     solid: true
        //   });
        // }
      } else {
        // For non-scraped jobs, follow existing profile strength logic
        if (this.profileStrength > 80) {
          //console.log("total strength inside if statement after Employee Skill section: ", this.profileStrength);
          this.isModalVisible = true;
          this.isSignInOrSignUpSection = false;
          this.isEmployeeProfileFormSection = true;
          this.isShowAlertMsg = false;
          this.isShowProfileInfoCard = true;
          this.isApplyJobConfirmationSection = true;
          //console.log("job strength inside if statement: ", this.profileStrength);
          //console.log("jobRecord inside if statement: ", this.jobRecord);
        } else {
          //console.log("this is the profile strength",this.profileStrength);
          this.$bvToast.toast("Your profile Strength Must be Over 80%, Please Update your Profile", {
            toaster: "b-toaster-top-center",
            variant: "warning",
            solid: true
          });
          this.isModalVisible = true;
          //console.log("job strength inside else statement: ", this.profileStrength);
          this.isSignInOrSignUpSection = false;
          this.isEmployeeProfileFormSection = true;
          this.isShowAlertMsg = true;
          this.isShowProfileInfoCard = false;
          this.isApplyJobConfirmationSection = false;
        }
      }
    } else {
      this.isConfirmationModalVisible = true;
    }
  } else {
    // User is not signed in, show sign-in modal
    //console.log("check : ", this.$auth.check());
    this.isModalVisible = true;
    this.isEmployeeProfileFormSection = false;
    this.isSignInOrSignUpSection = true;
    this.isShowAlertMsg = false;
    this.isShowProfileInfoCard = false;
    this.isApplyJobConfirmationSection = false;
  }
},
 

    onSavingJob(jobrecord) {
      this.jobRecord = jobrecord;
      if (this.$auth.check()) {
        this.saveJob.jobId = Number(jobrecord.jobId);
        this.saveJob.employeeId = Number(this.employeeId);
        //console.log("jobId + Emp ID : ", this.saveJob.jobId + this.saveJob.employeeId)
        axios
          .post("/api/Job/SaveJob", this.saveJob)
          .then(res => {
            // code that we will 'try' to run
            this.info = res.data;

            //console.log("Add Response portion");

            //console.log("response : ", this.info.msg);
          })
          .catch(error => {
            //console.log("Errorrrrrr : ", error);
            this.errored = true;
          })
          .finally(() => {
            if (this.info.msg == "Job Already Save") {
              this.$bvToast.toast("You have Saved to the Job Already. ", {
                toaster: "b-toaster-top-center",
                variant: "warning",
                solid: true
              });
            }
            else {
              this.$bvToast.toast("Job Saved Successfully", {
                toaster: "b-toaster-top-center",
                variant: "success",

                solid: true
              });
            }
            // this.getAll();
            // this.getAllEmployees();
          });
      }
      else {
        this.$bvToast.toast("Please Register / Log In, Before Saving a job", {
          toaster: "b-toaster-top-center",
          variant: "warning",

          solid: true
        });
        setTimeout(this.showSignUpOrSignInModal(), 1000)
      }
    },

    showSignUpOrSignInModal() {
      this.isModalVisible = true;
      this.isSaveJobStatus = true;
      this.isEmployeeProfileFormSection = false;

      this.isSignInOrSignUpSection = true;
      this.isShowAlertMsg = false;
      this.isShowProfileInfoCard = false;
      this.isApplyJobConfirmationSection = false;
    },

    toggleModal() {
      this.isModalVisible = !this.isModalVisible;
      this.getAll();
    },
    recievedStrength(value) {
      this.profileStrength = value;
      //console.log("On All JOb Page: ", this.profileStrength);
    },
    CalculatePercentage() {
      let profilePercentUponSignUp = 50;
      let profilePercent = 40;
      // let expPercent = 20;
      // let eduPercent = 20;
      let skillPercent = 10;
      let percent = 0;
      if (this.employeelist != {}) {
        if ((this.employeelist.fullName != "" || this.employeelist.fullName != null) && (this.employeelist.mobileNumber != "" || this.employeelist.mobileNumber != null)) {
          percent += profilePercentUponSignUp;
          //console.log("percent in signup : ", percent)
        }
        this.profileStrength = Math.ceil(percent);
        //console.log("total after Employee section : ", this.profileStrength);
        if (this.employeelist.gender != 0 && this.employeelist.gender != null) {
          percent += profilePercent;
          //console.log("percent in Profile : ", percent)
        }
        this.profileStrength = Math.ceil(percent);
        //console.log("total after Employee section : ", this.profileStrength);
      }
      this.profileStrength = Math.ceil(percent);
      //console.log("total after Employee section : ", this.profileStrength);
      if (this.employeeSkill.length != 0) {
        percent += skillPercent;

      }

      this.profileStrength = Math.ceil(percent);
      //console.log("total after Employee Skill section : ", percent);


    },

    onAreaExpand() {
      if (this.isAreaExpanded == false) {
        this.isAreaExpanded = true;
      }
      else {
        this.isAreaExpanded = false;
      }
    },
    rerender() {
      this.componentKey += 1;
    },
    closeModal() {
      // $("#addorEditModal").modal("hide");
      this.isConfirmationModalVisible = false;
    },
  }
}
</script>
<style scoped>
/* Skeleton Loading Styles */
.skeleton-container {
  padding: 15px;
}

.skeleton-card {
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 20px;
  margin-bottom: 20px;
}

.skeleton-row {
  display: flex;
}

.skeleton-col-main {
  flex: 1;
  padding-right: 20px;
}

.skeleton-col-side {
  width: 120px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.skeleton-line {
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 4px;
  margin-bottom: 12px;
}

.skeleton-line.title {
  height: 28px;
  width: 70%;
  margin-bottom: 15px;
}

.skeleton-line.meta {
  height: 16px;
  width: 50%;
}

.skeleton-line.tags {
  height: 24px;
  width: 60%;
  margin-bottom: 15px;
}

.skeleton-line.description {
  height: 16px;
  width: 100%;
}

.skeleton-line.description-short {
  height: 16px;
  width: 80%;
}

.skeleton-button {
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  height: 38px;
  width: 100%;
  border-radius: 4px;
  margin-bottom: 15px;
}

@keyframes shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

/* Animation for loading */
.w3-animate-opacity {
  animation: opac 0.5s ease-in-out;
}

@keyframes opac {
  from { opacity: 0.4; }
  to { opacity: 1; }
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .skeleton-row {
    flex-direction: column;
  }
  .skeleton-col-side {
    width: 100%;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 15px;
  }
  .skeleton-button {
    width: 48%;
  }
}
.skeleton-container, .job-content {
  transition: opacity 0.3s ease;
}
/*this css for the category checkboxes */
.category-skeleton {
  padding: 0.5rem;
}

.skeleton-checkbox {
  display: flex;
  align-items: center;
  height: 24px;
}

.skeleton-checkbox-box {
  width: 16px;
  height: 16px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 3px;
  margin-right: 8px;
}

.skeleton-checkbox-label {
  width: 80%;
  height: 16px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 3px;
}

@keyframes shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
/* Existing styles */
.modal-header h4 {
  font-weight: bolder;
  color: #000;
}

.modal-body p {
  font-weight: normal;
}

.modal-body p label {
  font-weight: normal;
}

.custom-collapse {
  background-color: #f7f7f7;
}

.headingstyles {
  font-size: x-large;
}

@media screen and (min-width: 720px) {
  .headingstyles {
    font-size: xx-large;
  }
}

.hideDiv {
  display: none;
}

.btn-theme {
  padding: 2px 20px !important;
}

.btn-active-page {
  background-color: #000 !important;
  color: #fff !important;
  font-weight: bold;
}

.btn-active-page{
  color: black !important;
  background-color: white !important;
}
</style>